import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TalentSettingsPasswordComponent } from "./talent-settings-password.component";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { PasswordValidationTipsModule } from "../../../../../../../../common-ui/src/lib/password-validation-tips/password-validation-tips.module";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [TalentSettingsPasswordComponent],
  imports: [
    CommonModule,
    NzButtonModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzWaveModule,
    PasswordValidationTipsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [TalentSettingsPasswordComponent],
})
export class TalentSettingsPasswordModule {}
